import { render, staticRenderFns } from "./2016.vue?vue&type=template&id=0d5624d7&"
import script from "./2016.vue?vue&type=script&lang=js&"
export * from "./2016.vue?vue&type=script&lang=js&"
import style0 from "./2016.vue?vue&type=style&index=0&id=0d5624d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports